/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import LIB from '../data/library.json'

export const APP_LIBRARY_URL = 'https://app.sequoia.fitness/sequoia-library'
export const EXERCISES = LIB
export const libPath = (id) => '/sequoia-library/' + id + '/'
export const videoSrc = (id) => '/lm/v/' + id + '.mp4'
export const posterSrc = (id) => '/lm/p/' + id + '.webp'
export const thumbSrc = (id) => '/lm/t/' + id + '.webp'

const KIND_COLORS = ['#fda4af', '#67e8f9', '#fdba74', '#7dd3fc', '#bef264', '#a5b4fc', '#f0abfc', '#fde047', '#5eead4', '#f9a8d4', '#c4b5fd']
export function kindColor(name) {
  let h = 0
  for (const ch of String(name)) h = (h * 31 + ch.charCodeAt(0)) >>> 0
  return KIND_COLORS[h % KIND_COLORS.length]
}

export function similarOf(id, count = 4) {
  const i = EXERCISES.findIndex((e) => e.id === id)
  const out = []
  for (let k = 1; out.length < count && k < EXERCISES.length; k++) out.push(EXERCISES[(i + k) % EXERCISES.length])
  return out
}
